import React from 'react';

const MonthHeader = ({ month }) => {
  if (!month) return null;
  
  return (
    <tr className="text-sm text-gray-900 dark:text-gray-100">
      <th 
        scope="colgroup" 
        colSpan={7} 
        className="relative isolate py-2 px-4 font-semibold text-left bg-gray-50 dark:bg-gray-700 border-y border-gray-200 dark:border-gray-600"
      >
        <time>{month}</time>
      </th>
    </tr>
  );
};

export default MonthHeader;